<template>
  <div>
    <v-breadcrumbs class="px-0" :items="items"></v-breadcrumbs>
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <div v-if="!isLoading">
      <Layout1 v-if="onlineExhibition.template_id === 1" />
      <Layout2 v-if="onlineExhibition.template_id === 2" />
    </div>
  </div>
</template>

<script>
import Layout1 from "../../components/online_exhibition_layout/Layout1";
import Layout2 from "../../components/online_exhibition_layout/Layout2";
import { mapState } from "vuex";
import Loading from 'vue-loading-overlay';

export default {
  components: {
    Layout1,
    Layout2,
    Loading
  },
  methods: {},
  computed: {
    ...mapState({
      branchName: state => state.Branch.branch_name,
      lang: state => state.Branch.lang,
      onlineExhibition: state => state.Article.onlineExhibition
    }),
    branchChanged: function () {
      return this.branchName;
    }
  },
  watch: {
    branchChanged: function () {
      this.items[0].text = this.branchName;
    }
  },
  async created() {
    this.isLoading = true;
    await this.$store.dispatch('Article/onGetOnlineExhibitionsById', { id: this.$route.params.id, lang: this.lang });
    this.isLoading = false;
  },
  data: () => ({
    item: {
      layout: 2 // TODO :: change dynamic layout value
    },
    isLoading: false,
    items: [
      {
        text: "TCDC BANGKOK",
        to: "/home"
      },
      {
        text: "SERVICE",
        href: "/service"
      },
      {
        text: "RESOURCE CENTER",
        href: "/service/resource-center"
      },
      {
        text: "ONLINE EXHIBITION",
        href: "/service/resource-center/online-exhibition"
      }
    ],
    events: [
      {
        name: "master of materials",
        time: "14 Aug - 13 Oct 2019",
        place: "TCDC Bangkok",
        highlight: false
      },
      {
        name: "master of materials",
        time: "14 Aug - 13 Oct 2019",
        place: "TCDC Bangkok",
        highlight: false
      },
      {
        name: "master of materials",
        time: "14 Aug - 13 Oct 2019",
        place: "TCDC Bangkok",
        highlight: false
      },
      {
        name: "master of materials",
        time: "14 Aug - 13 Oct 2019",
        place: "TCDC Bangkok",
        highlight: false
      }
      // 4 และ highlight
    ]
  })
};
</script>

<style lang="scss" scoped>
</style>
